import { Component, Input } from '@angular/core'
import { Observable } from 'rxjs'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'
import { ProviderInfo } from 'src/app/shared/models/provider-info.model'

@Component({
  selector: 'app-observations-data',
  templateUrl: './observations-data.component.html',
  standalone: false,
})
export class ObservationsDataComponent {
  public layerIds = Layers
  public isProvider1ObservationsVisible: boolean | undefined
  public isProvider2ObservationsVisible: boolean | undefined
  @Input() providerInfo$!: Observable<ProviderInfo>

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers()
    this.isProvider1ObservationsVisible = layers?.some(
      (layer) => layer === Layers.Provider1Observations.name,
    )
    this.isProvider2ObservationsVisible = layers?.some(
      (layer) => layer === Layers.Provider2Observations.name,
    )
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.Provider1Observations.name:
        this.isProvider1ObservationsVisible = !this.isProvider1ObservationsVisible
        break
      case Layers.Provider2Observations.name:
        this.isProvider2ObservationsVisible = !this.isProvider2ObservationsVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !layer.includes(Layers.Provider1Observations.name) &&
          !layer.includes(Layers.Provider2Observations.name),
      )

    if (this.isProvider1ObservationsVisible) {
      layers.push(Layers.Provider1Observations.name)
    }
    if (this.isProvider2ObservationsVisible) {
      layers.push(Layers.Provider2Observations.name)
    }
    this.appState.setState(AppPaths.Internal, {
      layers: layers?.toString(),
    })
  }
}
